import { PageLoading } from "../PageLoading";
import { ErrorText } from "../errors/ErrorText";
import { Box } from "@mui/material";
import { AsyncState } from "src/utils/async/asyncState";

export interface AsyncRenderProps<T> {
	asyncData: AsyncState<T>;
	content?: (data: T) => React.ReactNode;
	noContainer?: boolean;
}

export function AsyncRender<T>({ asyncData, content, noContainer = false }: AsyncRenderProps<T>) {
	const { data, loading, error } = asyncData;

	if (error != undefined) {
		return <ErrorText error={error} />;
	}

	if (noContainer && data !== undefined && content !== undefined) return content(data);

	// Render content always inside loading spinner container to avoid
	// remounts when loading state changes
	// This can be
	return (
		<Box
			sx={{
				display: "flex",
				flex: 1,
				position: "relative",
			}}
		>
			{data !== undefined && content !== undefined && content(data)}
			{loading && <PageLoading overlay />}
		</Box>
	);
}
